import getWithToken from './base/get-with-token'

const getDataAlertImport = getWithToken(`/customer-data-alert-import`)

export default getDataAlertImport
